<script setup lang="ts">
import FormField from "@/components/common/FormField.vue3.vue"
import { SignatureDocumentFieldType } from '@/store/enums';
import {ref, computed, onMounted, Ref} from 'vue';
import { usePortalIntakeStore } from '@/store/PortalIntakeModule';

const props = defineProps<{
    documentIndex: number,
    fieldIndex: number
}>();
const emit = defineEmits<{ (e: 'update'): void }>();

const intakeStore = usePortalIntakeStore();
const validationState = computed(() => intakeStore.getters.getSignatureFieldValidationState({ docIndex: props.documentIndex, fieldIndex: props.fieldIndex }));
const setDocumentField = (docIndex: number, fieldIndex: number, field: {type: SignatureDocumentFieldType, value: Ref<string|undefined>}) =>
    intakeStore.dispatch('setDocumentField', {docIndex, fieldIndex, field});

const value = ref('');

onMounted(() =>
    setDocumentField(props.documentIndex, props.fieldIndex, {type: SignatureDocumentFieldType.Name, value})
);
</script>

<template>
    <div>
        <form-field
            v-slot="{ onBlur }"
            :validation-state="validationState"
        >
            <p-input-text
                v-model="value" 
                placeholder="Patient Name"
                :class="validationState?.invalid && 'field-validation-error'"
                @blur="onBlur"
                @input="emit('update')"
            />
        </form-field>
        <span class="signature-form-data signature-form-patient-name">
            {{ value }}
        </span>
    </div>
</template>

<style scoped lang="scss">
.validation-error {
    background-color: #ffbdbd;
}
</style>
